import './NotificationSettings.css';
export var overlayText = '_1xx3fun0-2-0-1';